// Module
var code = "<div ng-transclude></div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/common/ui-elements/directives/sbHeaderBar/header_bar.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;